export enum ProcessLogMessageType {
  None = 0,
  Message = 1,
  Warning = 2,
  Error = 3,
  // Build-pipeline state events ("Build started", "Compile complete", …) — distinct from
  // log lines (`Message` = info-severity output) so the build-logs grid can filter them
  // independently. Server-side persistence still uses Message/Warning/Error; this value is
  // synthesized client-side from the live SSE stream's `k="e"` envelopes.
  Event = 4
}
